
export type TrackMetric200 = {
  status?: string;
};
